<template>
  <div id="Recharge">
    <div class="recharge-content">
      <div class="common-header">
        <es-breadcrumb>
          <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
          <es-breadcrumb-item>{{ $t('充值') }}</es-breadcrumb-item>
        </es-breadcrumb>
      </div>
      <divided />

      <div class="recharge-area">
        <es-form :model="rechargeForm" :rules="rules" ref="rechargeForm">
          <es-form-item class="recharge-line">
            <p class="label" slot="label">{{ $t('当前余额:') }}</p>
            <span class="common-money">{{ balance }}</span
            >{{ $t('元') }}</es-form-item
          >
          <es-form-item class="recharge-line" prop="rechargeAmount">
            <p class="label" slot="label">{{ $t('充值金额:') }}</p>
            <es-input class="width-280" v-model="rechargeForm.rechargeAmount" :placeholder="$t(`请输入充值金额`)"></es-input>
            <span class="unit">{{ $t('元') }}</span>
          </es-form-item>
          <es-form-item class="payment-way" prop="paymentOthWay">
            <p class="label" slot="label">{{ $t('支付方式:') }}</p>
            <div class="payment-selecter">
              <div
                class="payment-block"
                :class="{ active: rechargeForm.paymentOthWay === 'alipay' }"
                @click="handlePaymentOthWayClick('alipay')"
              >
                <img src="./../../assets/payment/Alipay.png" :alt="$t(`支付宝`)" />
              </div>
            </div>
          </es-form-item>
        </es-form>
        <div class="button-area">
          <es-button type="primary" style="margin: 10px 0" @click="handleConfirmRecharge()">{{ $t('确认充值') }}</es-button>
        </div>
        <div v-html="apply" ref="apply"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { debounce } from '@/util.js'
import divided from '../../components/divided'

export default {
  name: 'Recharge',
  components: {
    divided,
  },
  data() {
    const validRechargeAmount = (rule, value, callback) => {
      if (!value) {
        callback(new Error($t('请填写充值金额')))
      }
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error($t('请填写正确的充值金额，保留2位有效数字')))
      }
      if (value <= 0) {
        callback(new Error($t('请填写正确的充值金额，保留2位有效数字')))
      }
      callback()
    }

    const validPaymentOthWay = (rule, value, callback) => {
      if (!value) {
        callback(new Error($t('请选择支付方式')))
      }
      callback()
    }

    return {
      balance: 0,
      rechargeForm: {
        rechargeAmount: null,
        paymentOthWay: 'alipay',
      },
      rules: {
        rechargeAmount: [{ validator: validRechargeAmount, trigger: 'blur' }],
        paymentOthWay: [{ validator: validPaymentOthWay, trigger: '' }],
      },
      paymentForm: '',
      apply: '',
    }
  },
  created() {
    this.getBalanceInfo()
  },
  methods: {
    // 获取账户余额
    getBalanceInfo() {
      const params = {}
      this.$ajax(this.$url.getAccountWalletAmount(), params).then(res => {
        this.balance = res.data.balance
      })
    },
    // 选择第三方支付方式
    handlePaymentOthWayClick(arg) {
      this.rechargeForm.paymentOthWay = arg
    },
    open() {},
    // 第三方支付
    async thirdPartPayment(arg) {
      const params = {}
      params.type = this.rechargeForm.paymentOthWay
      params.payOrderId = arg
      const returnUrl = `${window.location.origin}/MyWallet`

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.thirdPartPay(params.type, params.payOrderId), { returnUrl })
          .then(res => {
            this.apply = res.data
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 创建订单
    async createOrder() {
      return new Promise((resolve, reject) => {
        const params = {}
        params.amount = this.rechargeForm.rechargeAmount
        this.$ajax(this.$url.rechargeOnline(), params)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 开始充值
    handleConfirmRecharge: debounce(
      function handleConfirmRecharge() {
        this.$refs.rechargeForm.validate(async valid => {
          if (valid) {
            this.safariWindowOpen(async () => {
              const resOrderId = await this.createOrder()
              this.payOrderId = resOrderId.data
              const resThirdPartPayment = await this.thirdPartPayment(resOrderId.data)
              const routerData = this.$router.resolve({ path: '/tempMidPay', query: { htmls: resThirdPartPayment.data } })

              return routerData.href
            })
          }
        })
      },
      2000,
      true
    ),

    // eslint-disable-next-line consistent-return
    safariWindowOpen(callback) {
      const { userAgent } = navigator // 取得浏览器的userAgent字符串
      if (userAgent.indexOf('Safari') > -1) {
        // 判断是否Safari浏览器
        const winRef = window.open('', '_blank')
        callback().then(res => {
          winRef.location.href = res // 改变页面的 location
          this.$router.replace({
            path: '/result',
            query: {
              payOrderId: this.payOrderId,
              orderType: 'charge',
            },
          })
        })

        return
      }
      callback().then(res => {
        window.open(res)
        this.$router.replace({
          path: '/result',
          query: {
            payOrderId: this.payOrderId,
            orderType: 'charge',
          },
        })
      })
    },
  },
}
</script>
<style lang="less" scoped>
#Recharge {
  .recharge-content {
    .recharge-area {
      padding-left: 20px;
      .label {
        width: 60px;
        margin-right: 20px;
      }
      .recharge-line {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin: 20px 0;
        .unit {
          margin-left: 10px;
          color: #333333;
        }
      }
      .payment-way {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin: 20px 0;
        .payment-selecter {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          .payment-block {
            width: 156px;
            height: 67px;
            border: 1px solid #e8e8e8;
            overflow: hidden;
            margin-right: 20px;
            padding: 14px 0;
            cursor: pointer;
            img {
              width: 100%;
            }
          }
          .active {
            border: 1px solid #0975e0ff;
          }
        }
      }
      .button-area {
        margin-left: 92px;
      }
    }
  }

  .width-280 {
    width: 280px;
  }
}
</style>
